export default "__VITE_ASSET__CexY1D0U__"